import { Box, Typography, Card, CircularProgress } from '@mui/joy'
import Button from '@mui/joy/Button'
import AddRoundedIcon from '@mui/icons-material/AddRounded'
import ChatApisPreview from 'components/ChatApisPreview/ChatApisPreview'

import IntegrationList from 'components/IntegrationList/IntegrationList'

type Props = {}

const MessengersPage = (props: Props) => {
    return (
        <>
            <Box
                sx={{
                    display: 'flex',
                    my: 1,
                    gap: 1,
                    flexDirection: { xs: 'column', sm: 'row' },
                    alignItems: { xs: 'start', sm: 'center' },
                    flexWrap: 'wrap',
                }}
            >
                <Typography level="h2">Integrations</Typography>
            </Box>
            <Box
                sx={{
                    display: 'flex',
                    gap: 2,
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mb: 2,
                }}
            >
                <Typography level="h4">
                    Choose what you want to connect:
                </Typography>
                <ChatApisPreview />
            </Box>
            <Box>
                <IntegrationList />
            </Box>
        </>
    )
}

export default MessengersPage
